export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY';

export const companyActions = {
  setCurrentCompany: (currentCompany) => ({
    type: SET_CURRENT_COMPANY,
    payload: currentCompany
  })
};
